import React, { ReactElement } from 'react';

import { Col, Layout, Row, Spin } from '@components/atoms';

function Init({ loading = false }: { loading: boolean }): ReactElement {
  return (
    <Layout>
      <Row yzTypeRow="center">
        <Col>
          <Spin spinning={loading}>
            <></>
          </Spin>
        </Col>
      </Row>
    </Layout>
  );
}

export default Init;
